import { render } from "./CampaignAddFile.vue?vue&type=template&id=fc9e858a&scoped=true"
import script from "./CampaignAddFile.vue?vue&type=script&lang=js"
export * from "./CampaignAddFile.vue?vue&type=script&lang=js"

import "./CampaignAddFile.vue?vue&type=style&index=0&id=fc9e858a&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9e858a"]])

export default __exports__